import * as Sentry from '@sentry/capacitor';
import * as SentryReact from '@sentry/react';
import { SENTRY_DSN } from 'src/config';

const install = () => {
  if (import.meta.env.PROD) {
    Sentry.init(
      {
        dsn: SENTRY_DSN,
        tracePropagationTargets: [
          'localhost',
          /^https:\/\/pari\.delivery/,
          /^https:\/\/pari\.mx/,
        ],
        integrations: [SentryReact.browserTracingIntegration()],
        // Performance Monitoring
        tracesSampleRate: 1.0,
      },
      SentryReact.init
    );
  }
};

export default { install };
